export default __webpack_public_path__ + "static/media/BrainBreak cards47.c5f79b20.png";